import {useFormik} from 'formik';
import {useState} from 'react';
import {CreateFundraiserStoryDTO, useFundraiserStories} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {DateTime} from '@gravity-ui/date-utils';

type UseAddAppealStoryFormProps = {
  appealId: string;
  setOpen: (open: boolean) => void;
};

export const useAddAppealStoryForm = ({appealId, setOpen}: UseAddAppealStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createStoryMutation} = useFundraiserStories({appealId});

  const onSubmit = async (values: {title: string; date: DateTime | null; previewImageUploadId: string}) => {
    setErrorMessage(null);
    try {
      // Преобразуем DateTime в строку формата YYYY-MM-DD
      const dateString = values.date ? values.date.format('YYYY-MM-DD') : '';
      const dto: CreateFundraiserStoryDTO = {
        title: values.title,
        date: dateString,
        previewImageUploadId: values.previewImageUploadId,
      };
      await createStoryMutation.mutateAsync({appealId, dto});
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании истории');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      date: null as DateTime | null,
      previewImageUploadId: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
      date: Yup.mixed<DateTime>().required('Дата обязательна'),
      previewImageUploadId: Yup.string().required('Изображение обязательно'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createStoryMutation.isPending,
    submitError: createStoryMutation.error
      ? (createStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
